<template>
  <div v-if="course" class="course-box">
    <div class="course-header">
      <img :src="course.course_image" alt="course" class="image"/>
      <div class="info">
        <div class="title">
          <h2>{{ course.course_name }}</h2>
          <div class="duration">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" 
                 class="bi bi-clock-history" viewBox="0 0 16 16">
              <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z"/>
              <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z"/>
              <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
            </svg>
            <span>{{ course.total_course_video_duration }} ساعات</span>
          </div>
        </div>
        <p class="description">{{ course.course_description }}</p>

        <div class="course-info">
          <div class="items">
            <div class="item homework">
              <i class="bi bi-calendar-plus-fill"></i>
              <span>{{ course.course_homework_count }} واجب</span>
            </div>
            <div class="item exam">
              <i class="bi bi-calendar2-range-fill"></i>
              <span>{{ course.course_exam_count }} اختبار</span>
            </div>
            <div class="item video">
              <i class="bi bi-play-btn-fill"></i>
              <span>{{ course.course_video_count }} فيديو</span>
            </div>
          </div>

          <div class="price">
            <p><span>{{ course.course_price }}</span>ج.م</p>
          </div>
        </div>

        <button 
          class="btn-subscribe" 
          @click="openModal(course.id)" 
          :disabled="course.subscription_status === 'مشترك بالفعل' || course.subscription_status === 'مجاني'"
          :class="{'btn-disabled': course.subscription_status === 'مشترك بالفعل'}"
        >
          {{ course.subscription_status === 'مشترك بالفعل' ? '✔️ مشترك بالفعل' : course.subscription_status }}
        </button>

        <PaymentMethodModal 
          :isOpen="isModalOpen" 
          :courseId="selectedCourseId" 
          @close="closeModal" 
          @subscription-successful="handleSubscriptionSuccess"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaymentMethodModal from '../PaymentMethodModal.vue';

export default {
  name: "CourseHeader",
  components: { PaymentMethodModal },
  props: {
    course: { type: Object, required: true },
    isModalOpen: { type: Boolean, required: true },
    selectedCourseId: { type: Number, default: null },
    isEnrolled: { type: Boolean, default: false }
  },
  emits: ["open-modal", "close-modal", "subscription-successful"],
  methods: {
    openModal(id) {
      this.$emit("open-modal", id);
    },
    closeModal() {
      this.$emit("close-modal");
    },
    handleSubscriptionSuccess() {
      this.$emit("subscription-successful");
    }
  }
};
</script>
<style scoped>
.course-box {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.course-header {
  display: flex;
  gap: 38px;
  align-items: flex-start;
}

.course-header img {
  width: 380px;
  max-width: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.duration {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  color: #000;
  font-weight: 500;
}
.info {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.info .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
  font-weight: 600;
  color: #000;
  margin: 0;
  flex-wrap: wrap;
}
.info .title h2 {
  margin: 0;
}

.course-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.items {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.items .item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 500;
}
.items i {
  font-size: 18px;
}
.item.homework {
  background-color: #FF770033;
  color: #FF7700;
}
.item.exam {
  background-color: #15C01B33;
  color: #15C01B;
    display: flex;
  flex-direction: row !important;
}
.item.video {
  background-color: #15C0BD33;
  color: #15C0BD;
}

.price p {
  font-weight: 500;
  color: #000;
  font-size: 26px;
}
.price span {
  font-size: 42px;
  color: #FF9A18;
  padding-left: 6px;
}

.btn-subscribe {
  color: #FF9A18;
  font-size: 18px;
  font-weight: 500;
  border-radius: 24px;
  padding: 12px 24px;
  border: 1px solid #FF9A18;
  cursor: pointer;
  background: transparent;
  transition: 0.3s;
}
.btn-subscribe:hover:not(:disabled) {
  background: #FF9A18;
  color: #fff;
}
.btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.description {
  font-size: 22px;
  font-weight: 400;
  color: #7F8685;
  margin: 0;
  text-align: right;
}
@media (max-width: 948px) {
  .course-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .course-header img {
    width: 100%;
    max-width: 400px;
  }
  .info .title {
    gap: 8px;
    font-size: 22px;
    text-align: center;
  }
  .course-info {
    flex-direction: column;
    gap: 16px;
  }
  /* .items {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  } */
  .price p {
    font-size: 24px;
  }
  .price span {
    font-size: 36px;
  }
  .btn-subscribe {
    width: 100%;
  }
}
</style>

